import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import I18n from './i18n'
import './design/tokens.css'
import './design/global.css'
import { loadSiteRuntime } from './config/siteRuntime'

Vue.config.productionTip = false
Vue.use(I18n, { store })
document.documentElement.lang = store.state.preferences.language
store.dispatch('cart/hydrate')
loadSiteRuntime().then(site => {
  Vue.prototype.$site = site
  new Vue({ router, store, render: h => h(App) }).$mount('#app')
})
